/* eslint prefer-template: 0 */

const typesByPriority = [
    'DESTINATION',
    'ACTIVITIES',
    'POI',
    'CLIMATE',
    'GEOGRAPHY'
];

function hasSLPTag(p) {
    return p.tags.indexOf('slp') !== -1;
}

function hasSLPText(slpText, type) {
    return !!(slpText || {})[type];
}

function getSEOClasses(type, text) {
    const textClass = `seo-text-type-${text.textType.toLowerCase()}`;
    const descriptionClass = `seo-description-type-${type.toLowerCase()}`;
    return `${textClass} ${descriptionClass}`;
}

function getSEOContent(text) {
    const paragraph = text.paragraphs.find(hasSLPTag) || text.paragraphs[0];
    return paragraph.content;
}

// this is a string because `content` contains markup from the seo crm
function asSEODiv(slpText, type) {
    const text = slpText[type];
    const classes = getSEOClasses(type, text);
    const content = getSEOContent(text);

    return `<div class="${classes}">${content}</div>`;
}

export function getSlpText(slpText) {
    return typesByPriority
        .filter(hasSLPText.bind(null, slpText))
        .map(asSEODiv.bind(null, slpText))
        .join('');
}
